angular.module('impactx.search').component('ixSearchFilter', {
        bindings: {
            onFilterChange: '&',
            trns: '<',
            hideSupplier: "<",
            hideCountry: "<",
            hideProductFamily: "<",
            hideProcurementGroup: "<",
            hideManufacturer: "<",
            showSearchInput: "<",
            useListFilters: "<",
            object: "@",
            baseObject: "@",
            needsReset: "=",
            hideDefaultFilters: "="
        },
        controller: 'SearchFilterCtrl',
        controllerAs: 'filterCtrl',
        templateUrl: 'modules/search/templates/search-filter.html'
    }
);
